// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Widget_gallery__zqy5c","center":"Widget_center__2EBVa"};